var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"url":"ivr/provider","model":"Provider","fields":_vm.fields,"action-buttons":"","primary-key":"slug","no-modal":"","create":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }